import styled from 'styled-components'
// components
import { Scrollbar } from 'components/UI'
// themes
import { colors } from 'themes/index'
// icons
import { EditIcon } from 'components/PageComponents/Settings/ObjectsAndProperties/Edit/Properties/components/Property/view'
// views
import { Collapse } from 'components/Modals/PlanItems/styles'

export const Form = styled.form`
  overflow: hidden;
  display: flex;
  height: 100%;
  flex-direction: column;

  ${Collapse} {
    font-size: 16px;
  }

  ${EditIcon} {
    path {
      fill: ${colors.blue300};
    }
  }

  ${Scrollbar} {
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 16px;
  }

  > :last-child {
    padding: 16px;
    margin-top: auto;
  }
`

export const AvailableUsersWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: -16px;
  border-top: 1px solid grey;

  > div:not(:first-child) {
    margin-top: 0;

    > div {
      max-width: unset;
    }
  }
`
